<template>
  <div class="st-grey-box" @click="goReceivingMethod">
    <div class="st-editable-item">
      <div class="st-flexbox">
        <div class="st-flex-title">
          <div>お受取方法</div>
        </div>
        <div v-if="RECEIVE_TYPES.DIRECT === receiveType && receiveMethod" class="st-flex-content">
          <div>ご来店</div>
          <div class="sub">{{ selectedReceiveMethod }}</div>
        </div>
        <div v-else-if="RECEIVE_TYPES.DELIVERY === receiveType && selectedAddress" class="st-flex-content">
          <div>ご配送&nbsp;:&nbsp;{{selectedAddress.addressbookname}}</div>
          <div class="sub" v-if="delivery.day">
            指定日&nbsp;:&nbsp;{{delivery.day | formatDate('YYYY-MM-DD', 'YYYY/MM/DD(ddd)')}}
          </div>
          <div class="sub" v-if="delivery.time">
            指定時間&nbsp;:&nbsp;{{delivery.time}}
          </div>
          <div class="sub">
            {{selectedAddress.zipcode1}}-{{selectedAddress.zipcode2}} {{selectedAddress.prefecture}}
            {{selectedAddress.address1}} {{selectedAddress.address2}}
          </div>
        </div>
        <div v-else class="st-flex-content">
          <div>選択してください</div>
          <div class="sub">※ご来店または、ご配送でのお受け取りが可能です。</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { RECEIVE_TYPES } from '../../../config/constant-types'

export default {
  data () {
    return {
      RECEIVE_TYPES: RECEIVE_TYPES
    }
  },
  computed: {
    ...mapGetters([
      'selectedAddress'
    ]),
    ...mapState({
      receiveMethodShops: state => state.delivery.remote.receive_method_shops,
      receiveType: state => state.delivery.input.receiveType,
      receiveMethod: state => state.delivery.input.receiveMethod,
      delivery: state => state.delivery.input.delivery
    }),
    selectedReceiveMethod () {
      const selectedReceiveMethod = this.receiveMethodShops.find(s => {
        return s.shopid.toString() === this.receiveMethod.toString()
      })
      if (selectedReceiveMethod) {
        return selectedReceiveMethod.name
      } else {
        return ''
      }
    }
  },
  methods: {
    async goReceivingMethod () {
      await this.$router.push({ name: 'receiving_method' })
      window.scrollTo(0, 0)
    }
  }
}
</script>
